import { useCallback, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";

const readAuth = () => {
  try {
    const logindata = JSON.parse(localStorage.getItem("logindata"));
    const token = logindata?.data?.token;
    if (!token) return { isAuthenticated: false };
    const decoded = jwtDecode(token);
    if (decoded?.exp && decoded.exp * 1000 < Date.now()) {
      return { isAuthenticated: false };
    }
    return {
      isAuthenticated: true,
      token,
      userId: decoded?.userId ?? decoded?.sub,
      role: decoded?.role,
      phone: decoded?.phone,
    };
  } catch (e) {
    return { isAuthenticated: false };
  }
};

export const useAuthentication = () => {
  const [auth, setAuth] = useState(readAuth);

  useEffect(() => {
    const refresh = () => setAuth(readAuth());
    window.addEventListener("storage", refresh);
    window.addEventListener("authChange", refresh);
    return () => {
      window.removeEventListener("storage", refresh);
      window.removeEventListener("authChange", refresh);
    };
  }, []);

  const removeToken = useCallback(() => {
    localStorage.removeItem("logindata");
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("userId");
    window.dispatchEvent(new Event("authChange"));
  }, []);

  return { ...auth, removeToken };
};
